<div class="after-submit-screen">
  <div class="d-flex flex-column h-100">
    <div class="adult after-submit-screen-wrapper d-flex px-0" [style.background-image]="'url(' + imageBasePath+ 'assets/img/secondary-background.jpg)'">
      <div class="content-container w-100">
        <div class="d-flex flex-column text-center h-100">
          <div class="content-wrapper text-center">
            <div class="heading-msg">
              <h2>{{'SHARED.SUBMIT_REDIRECTION_PAGE.HEADING_TEXT' | translate}}</h2>
              <p *ngIf="this.selectedItemData.__analytics.submitCount > 0" class="sub-heading mx-3  my-0" [innerHTML]="'SHARED.SUBMIT_REDIRECTION_PAGE.SUB_HEADING_1' | translate : {testName: selectedItemData?.name,
                submitCount: this.selectedItemData.__analytics.submitCount }">
              </p>
              <p class="sub-heading mx-3">
                {{'SHARED.SUBMIT_REDIRECTION_PAGE.SUB_HEADING_2' | translate}}
              </p>
            </div>
            <div class="green-tick-img my-4 my-md-5 align-self-center">
              <img alt="{{'SHARED.SUBMIT_REDIRECTION_PAGE.GREEN_TICK_ICON' | translate }}"
                src="{{imageBasePath}}assets/img/green-tick.svg">
            </div>
            <div class="description-msg">
              <p class="description mx-3" *ngIf='remainingAttempts === 0'>
                {{'SHARED.SUBMIT_REDIRECTION_PAGE.ATTEMPT_DESCRIPTION_1' | translate }}
              </p>
              <p class="description mx-3" *ngIf='remainingAttempts > 0' [innerHTML]="'SHARED.SUBMIT_REDIRECTION_PAGE.ATTEMPT_DESCRIPTION_2' | translate : {remainingAttempt:
                remainingAttempts}">
              </p>
            </div>
            <div class="d-inline-flex flex-column align-items-center pt-md-4 pt-lg-0">
              <p class="mb-4">
                <a qid="resultScreen-1" class="btn-primary btn" href="javascript:void(0)" #myhomeWorkBtn
                  (click)="navigateToMyHomework()">
                  {{(isAdultSegment ? 'SHARED.SUBMIT_REDIRECTION_PAGE.MY_ASSIGNMENTS_BUTTON' : 'SHARED.SUBMIT_REDIRECTION_PAGE.MY_HOMEWORK_BUTTON') | translate}}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>